import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import {
  CoursePauseRequestFilterChips,
  COURSE_PAUSE_REQUEST_TABS,
  setCoursePauseFilterModalState,
} from 'features/courseResume';
import styles from './CoursePauseRequestStatusPage.module.scss';

function CoursePauseRequestStatusPage() {
  const dispatch = useDispatch();
  const { requestType } = useParams();

  const handleFilterClick = useCallback(() => {
    dispatch(setCoursePauseFilterModalState(true));
  }, [dispatch]);

  return (
    <>
      <div className={styles.root}>
        <div className={styles.tabs}>
          {COURSE_PAUSE_REQUEST_TABS.map((tab, tabIndex) => (
            <NavLink
              key={tab.name}
              to={`/course-pause/${requestType}${tab.to}`}
              tabIndex={tabIndex}
              className={({ isActive }) =>
                classNames(styles.tab, { [styles.tabActive]: isActive })
              }
            >
              {tab.name}
            </NavLink>
          ))}
        </div>
        <Tappable
          className={classNames(styles.filter, 'btn btn-inverted')}
          onClick={handleFilterClick}
        >
          <Icon
            name="filter-alt"
            className="p-t-xxs m-r-xxs h5 cursor"
          />
          Filter
        </Tappable>
      </div>
      <CoursePauseRequestFilterChips />
      <Outlet />
    </>
  );
}

export default CoursePauseRequestStatusPage;
